export default [
  {
    path: '/apps/cliente/list',
    name: 'apps-cliente-list',
    component: () => import('@/views/cadastros/cliente/cliente/list/Index.vue'),
    meta: {
      action: 'read',
      resource: 'Auth',
    },
  },
  {
    path: '/apps/pre-cadastro-cliente',
    name: 'apps-pre-cadastro-cliente',
    component: () => import('@/views/cadastros/cliente/cliente/pre-cadastro/PreCadastroCliente.vue'),
    meta: {
      hidePageTitle: true,
    },
  },
];
